/* @ngInject */
function CampaignMaterialsTemplatesController ($scope, CampaignActionService) {
  $scope.location = 'materials'

  $scope.templateOptions = {
    edit: false,
    move: false,
    share: false,
    archive: false,
    download: false,
    settings: false,
    duplicate: false
  }

  const api = {
  }

  this.getApi = () => api

  activate()

  function activate () {
  }

  $scope.$watch('templates.rows', (newVal) => {
    if (!newVal || !$scope.selectedMaterials || !$scope.selectedMaterials.length) return
    newVal.forEach(template => {
      template.selected = $scope.selectedMaterials.some(material => material.id === template.id && 'isTemplate' in material)
    })
  })

  $scope.selectTemplate = (template) => {
    const templateIndex = $scope.selectedMaterials.findIndex(t => t.id === template.id && 'isTemplate' in t)
    if (templateIndex !== -1) {
      template.selected = false
      $scope.selectedMaterials.splice(templateIndex, 1)
      $scope.$emit('campaign.set-schedule-date', CampaignActionService.getSelectedScheduleDate($scope.selectedMaterials, $scope.selectedScheduleDate))
    } else {
      if (CampaignActionService.validateScheduleDateOnTemplateLink(template, $scope.selectedScheduleDate)) {
        $scope.$emit('campaign.set-schedule-date', $scope.selectedScheduleDate || template.templateScheduleDate)
        template.selected = true
        $scope.selectedMaterials.push(template)
      }
    }
  }

  $scope.isTemplateDisabled = (templateScheduleDate) => {
    if (!templateScheduleDate || !$scope.selectedScheduleDate) return false
    if (templateScheduleDate === $scope.selectedScheduleDate) return false
    return true
  }
}

export { CampaignMaterialsTemplatesController }
